// libs/shared/auth/src/lib/data-access/auth-config.service.ts

import { Injectable } from '@angular/core';
import { AuthConfig } from '../model/auth.interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthConfigService {
  private config: AuthConfig = {
    apiUrl: 'http://ec2-3-12-102-207.us-east-2.compute.amazonaws.com',
    loginEndpoint: '/api/auth/login/',
    logoutEndpoint: '/api/auth/logout/',
    registerEndpoint: '/api/auth/register/',
    profileEndpoint: '/api/auth/profile/',
    ownRoles: '/api/users/own/roles/',
    forgotPasswordEndpoint: '/api/auth/forgot-password/',
    resetPasswordEndpoint: '/api/auth/reset-password/',
    refreshTokenEndpoint: '/api/auth/token/refresh/',
    tokenRefreshInterval: 1000 * 60 * 59,
    tokenPrefix: 'Bearer',
    storagePrefix: 'auth_',
    enableOwnRolesRequest: true,
    postLoginRoute: undefined,
  };

  setConfig(config: Partial<AuthConfig>): void {
    this.config = { ...this.config, ...config };
  }

  getConfig(): AuthConfig {
    return { ...this.config };
  }

  getEndpointUrl(
    endpoint: keyof Omit<AuthConfig, 'apiUrl' | 'tokenPrefix' | 'storagePrefix'>,
  ): string {
    return `${this.config.apiUrl}${this.config[endpoint]}`;
  }
}
